import React from 'react';
import { DateTime } from "luxon";

import {Loading, Alert} from 'Components/Partials';
import {RenderWYSIWYG} from 'Components/Form';

import {translation} from 'Services/TranslationHelpers';
import {translationFromJson} from 'Services/TranslationHelpers2';

import AgendaIndex from './index';
import { dateToString } from "../../Services/DateHelpers";

export default class AgendaIndex2 extends AgendaIndex {
	/**
     * @method render
     * @return {*}
     */
    render () {
        const {loading, alert, agendas} = this.state;

        return (
            <div className="p-4 text-center">
                {loading && <Loading />}

                {!loading &&
                    <div>
                        {alert &&
                            <div className="px-8 py-4 mx-auto" id="alert">
                                <Alert {...alert} />
                            </div>
                        }

                        {!agendas || agendas.length === 0 &&
                            <p className="font-bold">
                                {translation('misc', 'no_items', {
                                    ITEM: translation('agenda', 'agenda')
                                })}
                            </p>
                        }

                        {agendas && agendas.length !== 0 &&
                            <div>
                                {this.renderDates()}
                                {this.renderAgendas()}
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }

    /**
     * @method renderDates
     * @return {*}
     */
    renderDates() {
        const {dates, active_date} = this.state;

        return (
            <div className="flex flex-row justify-center items-center text-center gap-3 bmw-bold text-md w-full bg-app-bmw-blue py-2">
                {dates && dates.map((date, i) => {
                    return (
                        <button
                            key={i}
                            onClick={() => this.setState({active_date: date})}
                            className={`
                            	px-3 py-1
                            	${active_date !== date ?
	                            	'bg-app-bmw-blue text-white' :
	                            	'bg-white text-app-bmw-blue'}
                            `}
                        >
                            Day {i+1}
                            <br />
                            {dateToString(date)}
                        </button>
                    )
                })}
            </div>
        );
    }

    /**
     * @method renderAgendas
     * @return {*}
     */
    renderAgendas() {
        const {agendas, active_date} = this.state;

        return (
            <div className="bg-app-cream flex flex-col px-6 text-center md:text-left text-app-green-dark">
                {agendas.filter(agenda => agenda.start_date_time.date_timezone === active_date).map((agenda, i) => (
                    <div
                        className={`
                            grid grid-cols-1 md:grid-cols-5 lg:grid-cols-6 gap-4 py-8
                            ${i !== 0 ? 'border-t-2 border-app-yellow' : ''}
                        `}
                        key={i}
                    >
                        <div className={"bmw-bold"}>
                            {agenda?.time_text ?? DateTime.fromISO(agenda.start_date_time.time_timezone).toFormat("a")}

                            {/*{agenda?.end_date_time &&*/}
                            {/*    <>*/}
                            {/*        {" "}- {agenda?.end_date_time?.time_timezone}*/}
                            {/*    </>*/}
                            {/*}*/}
                        </div>

                        <div className="md:col-span-3 lg:col-span-4">
                            <p className="bmw-light mb-2">
                                {translationFromJson(agenda.title)}
                            </p>

                             {agenda.content &&
                                <div className="mb-2 bmw-bold">
                                    <RenderWYSIWYG content={translationFromJson(agenda.content)} />
                                </div>
                            }

                            {agenda.presenters &&
                                <div className="mb-2 bmw-bold">
                                    <RenderWYSIWYG content={translationFromJson(agenda.presenters)} />
                                </div>
                            }
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}
